import { updateExtractedUrlData } from '../mutators/updateExtractedUrlData';
import { lazyLogSigsDatapoint } from 'owa-analytics';
import { ClientItem, ExtractedUrl } from 'owa-mail-store';
import hasUrlExtendedProperties from './hasUrlExtendedProperties';

export default function logToSigsWithLinkCustomProperties(
    clickedUrl: string,
    item: ClientItem,
    immutableEntryId: string,
    linkIndex: number
) {
    // Get EntityExtraction URL properties to create the custom properties
    const extractedUrlData: ExtractedUrl[] | undefined = getExtractedUrlData(item);
    let customProperties = { LinkClickedSequenceNumber: linkIndex };

    if (extractedUrlData) {
        // If the property exists, find the entry that matches the clicked url
        // And log the appropriate custom properties
        const matchedUrlData = findMatchingExtractedUrl(clickedUrl, extractedUrlData);
        if (!!matchedUrlData) {
            customProperties['TEEPropertyReference'] = matchedUrlData.TeePropertyReference;
            customProperties['EntityId'] = matchedUrlData.EntityId;
            customProperties['MessageVersion'] = 0;
        }
    }

    lazyLogSigsDatapoint.importAndExecute('LinkClicked', {
        itemId: immutableEntryId,
        customProperties: customProperties,
    });
}

function getExtractedUrlData(item: ClientItem): ExtractedUrl[] | undefined {
    if (hasUrlExtendedProperties(item) && !item.ExtractedUrlData) {
        updateExtractedUrlData(item);
    }

    return item.ExtractedUrlData;
}

function findMatchingExtractedUrl(
    clickedUrl: string,
    extractedUrlData: ExtractedUrl[]
): ExtractedUrl | null {
    if (!!extractedUrlData) {
        for (let i = 0; i < extractedUrlData.length; i++) {
            if (clickedUrl == extractedUrlData[i].Url) {
                return extractedUrlData[i];
            }
        }
    }

    return null;
}
